import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Breadcrumbs from '../UI/Breadcrumbs';
import ModalSingleInput from '../UI/modals/ModalSingleInput';
import ModalUploadFiles from '../UI/modals/ModalUploadFiles';
import ModalConfirm from '../UI/modals/ModalConfirm';
import ModalGrantAccessToFolder from '../UI/modals/ModalGrantAccessToFolder';
import useToast from '../../hooks/useToast';

import './FolderView.less';
import FolderViewTable from './FolderViewTable';

export default function FolderView(props) {
  const {
    content, accessType, parentId, permissions: perms,
  } = props;

  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showNewFolderModal, setShowNewFolderModal] = useState(false);
  const [renameFolderModal, setRenameFolderModal] = useState(null);
  const [deleteModalData, setDeleteModalData] = useState(null);
  const [copyTextModalData, setCopyTextModalData] = useState(null);
  const [accessModalData, setAccessModalData] = useState(null);
  const [accessModalData2, setAccessModalData2] = useState([]);
  const toast = useToast();

  const handleRowClick = (item) => {
    switch (item.type) {
      case 'folder':
        props.onFolderOpen(item);
        return;
      case 'file':
        props.onFileOpen(item);

      default:
    }
  };

  const handleDeleteItem = (item) => {
    switch (item.type) {
      case 'folder':
        return props.onFolderDelete(item);
      case 'file':
        return props.onFileDelete(item);
      default:
    }
  };

  useEffect(() => {
    copyTextModalData && onActionCopy(copyTextModalData);
  }, [copyTextModalData])
  
  const onActionCopy = async (item) => {
    try {
      await copyTextToClipboard(`<a filedownload="true" filename="${item.name}" id="${item.id}">Скачать файл</a>`);
      toast.success('Скопировано в буфер обмена!');
    } catch (err) {
      toast.error(err.message);
    }
  }

  const copyTextToClipboard = async (text) => {
    if ('clipboard' in navigator)
      return await navigator.clipboard.writeText(text);
    throw new Error('Не получилось скопировать ссылку на документ в буфер обмена или ваш браузер не поддерживает эту функцию')
  }

  const handleRenameItem = (value) => {
    return props.onFolderRename(value, renameFolderModal.id)
  }

  const handleRememberState = (id, ct, sm) => {
    const copy = Object.assign([], accessModalData2?.filter((e) => e?.id !== id));
    copy.push({ id, switch1: ct, switch2: sm });
    setAccessModalData2(copy);
  };

  return (
    <>
      <div className="folder-view">
        <div className="folder-view__toolbar mb-2">
          <div>
            {props.breadcrumbsProps && <Breadcrumbs {...props.breadcrumbsProps} />}
          </div>
          <div className="folder-view__toolbar-buttons">
            {perms.canUploadFiles ? <Button onClick={() => setShowUploadFileModal(true)}>Загрузить файлы</Button> : ''}
            {perms.canCreateFolder ? <Button onClick={() => setShowNewFolderModal(true)}>Создать папку</Button> : ''}
          </div>
        </div>
        <FolderViewTable
          content={content}
          accessType={accessType}
          permissions={perms}
          onRowClick={handleRowClick}
          onActionDelete={setDeleteModalData}
          onActionAccess={setAccessModalData}
          onActionRename={setRenameFolderModal}
          onActionCopyText={setCopyTextModalData}
        />
      </div>

      {showUploadFileModal && (
        <ModalUploadFiles
          onClose={() => setShowUploadFileModal(false)}
          onConfirm={props.onFilesUpload}
        />
      )}
      {showNewFolderModal && (
        <ModalSingleInput
          header="Создать папку"
          label="Укажите название"
          placeholder="Новая папка"
          onConfirm={props.onFolderCreate}
          onClose={() => setShowNewFolderModal(false)}
        />
      )}
      {renameFolderModal && (
        <ModalSingleInput
          header="Переименовать"
          label="Укажите другое название"
          placeholder={renameFolderModal.name}
          onConfirm={handleRenameItem}
          onClose={() => setRenameFolderModal(null)}
        />
      )}
      {deleteModalData && (
        <ModalConfirm
          headerText={`Вы хотите удалить ${deleteModalData.type === 'folder' ? 'папку' : 'файл'} "${deleteModalData.name}"?`}
          confirmBtnVariant="outline-danger"
          confirmBtnText="Удалить"
          message={deleteModalData.type === 'folder' && <span style={{ color: 'red', fontWeight: 'bold' }}>Папка и все ее содержимое будет удалено.</span>}
          onClose={() => setDeleteModalData(null)}
          onConfirm={() => handleDeleteItem(deleteModalData)}
        />
      )}
      {accessModalData && (
        <ModalGrantAccessToFolder
          headerText={accessModalData.name}
          confirmBtnText="Сохранить"
          accessType={accessModalData.accessType}
          id={accessModalData.id}
          visibleAccessType={accessModalData.visibleAccessType}
          parentId={parentId}
          onClose={() => setAccessModalData(null)}
          onConfirm={handleRememberState}
          external={accessModalData2}
        />
      )}
    </>
  );
}
